<template>
  <div class="row">

    <h3 v-if="title">{{ title }}</h3>
    <div class="row" style="margin-top:16px;">
      <PackageOrderForm ref="packageOrderFormComponent" :showSaveButton="false"/>
    </div>
    <div class="card shadow-sm mb-4">
      <div class="card-header bg-light">
        <h6 class="mb-0 text-primary fw-bold">
          <i class="fas fa-clinic-medical me-2"></i>Apteki
        </h6>
      </div>
      <div class="card-body">
        <div class="row">
          <div class="col-12">
            <label class="form-label">Przypisane apteki</label>

            <div class="input-group has-validation">
          <textarea
              v-model="drugstoresNames"
              class="form-control bg-white"
              :class="drugstoresNamesInputClass"
              id="drugstores-names-input"
              ref="drugstores-names-input"
              placeholder="Nie wybrano aptek..."
              aria-describedby="drugstores-names-input-feedback"
              rows="2"
              readonly
              style="cursor: pointer;"
              @click="openDrugstoresSelectList"
          ></textarea>

              <button
                  class="btn btn-outline-primary"
                  type="button"
                  @click="openDrugstoresSelectList"
              >
                <i class="fas fa-list-ul me-1"></i> Wybierz
              </button>

              <div
                  class="invalid-feedback"
                  id="drugstores-names-input-feedback"
                  v-if="drugstoresNamesInputClass && drugstoresNamesInputClass.includes('is-invalid')"
              >
                Należy wybrać co najmniej jedną aptekę
              </div>
            </div>
            <div class="form-text text-muted mt-1">
              Kliknij przycisk lub pole tekstowe, aby otworzyć listę wyboru.
            </div>
          </div>
        </div>

        <DrugstoreListModal
            :showModal="showDrugstoresSelectList"
            @update:showModal="showDrugstoresSelectList = $event"
            title="Dostępne apteki"
            @onApply="addDrugstoresToOrder($event)"
            :multiselect="true"
            :selectedDrugstoresData="groupOrderDrugstores"
        />
      </div>
    </div>

    <div class="action-buttons">
      <button class="btn btn-primary" @click="saveData">
        Utwórz zamówienie
      </button>
      <button class="btn btn-danger" style="margin-left:8px;" @click="cancelOrder">
        Anuluj
      </button>

    </div>



  </div>


</template>


<script>
import {defineComponent} from 'vue'
import PackageOrderForm from "./PackageOrderForm.vue";

import Swal from "sweetalert2";
import DrugstoreListModal from "@/views/DrugstoreCommonManager/DrugstoreListModal.vue";
import {usePackagesManagerModule} from "@/state/pinia/packagesManagerModule";
import {useSimplepharmAuthModule} from "@/state/pinia/simplepharmAuthModule";
import {useCommonAppModule} from "@/state/pinia/commonAppModule";
import {useLazyLoaderModule} from "@/state/pinia/lazyloaderManagerModule";
const user = JSON.parse(localStorage.getItem('user'));
export default defineComponent({
  name: "PackageOrderGeneratorAssistant",
  components: {DrugstoreListModal, PackageOrderForm},
  props: {
    title: String,
  },
  emits: ['onCreateSuccess','onCancelOrder'],
  data() {
    return {
      orderData: null,
      isOrderToDivide: false,
      showDrugstoresSelectList: false,
      orderDrugstoresCurrent: [],
      drugstoresNames:[],
      drugstoresNamesInputClass: "form-control",
    }
  },
  computed: {
    packagesModule(){
      return usePackagesManagerModule();
    },
    simplepharmAuth(){
      return useSimplepharmAuthModule();
    },
    commonModule(){
      return useCommonAppModule();
    },
    lazyloaderModule(){
      return useLazyLoaderModule();
    },
    groupOrderDrugstores() {
      return this.orderDrugstoresCurrent;
    }
  },
  methods: {
    openDrugstoresSelectList() {
      this.showDrugstoresSelectList = true
    },

    addDrugstoresToOrder(drugstores) {

      if (drugstores == null || drugstores.length === 0) {
        this.showDrugstoresSelectList = false;
        return;
      }

      // adding to drugstores list
      var currentDrugstores = JSON.parse(JSON.stringify(this.orderDrugstoresCurrent));
      if (currentDrugstores) {
        drugstores.forEach(drugstore => {
          const exists = currentDrugstores.some(
              d => d.drugstoreClientId === drugstore.drugstoreClientId
          );
          if (!exists) {
            currentDrugstores.push(drugstore);
          }
        });
        console.log("Adding drugstores to order:")
        console.log(currentDrugstores)
        this.orderDrugstoresCurrent = currentDrugstores;
       const namesArray = this.orderDrugstoresCurrent.map(drugstore => `[${drugstore.drugstoreClientId}] ${drugstore.name}`);
       // assign to string
       this.drugstoresNames = namesArray.join("\n");
       if(this.orderDrugstoresCurrent.length > 0) {
         this.drugstoresNamesInputClass = "form-control";
       }else{
          this.drugstoresNamesInputClass = "form-control is-invalid";
       }

      }
      this.showDrugstoresSelectList = false;
    },


    applyOrderDataForm() {
      // Spróbuj wywołać onApply w komponencie dziecka (jeśli istnieje)
      const child = this.$refs.packageOrderFormComponent;

      if (child && child.saveData) {
        // Jeśli onApply zwraca Promise, poczekaj na zakończenie
        const result = child.saveData();// onApplyData in packageOrderFormComponent is an object type
        console.log("Result from form")
        console.log(result)
        if (result) {
          this.saveFormData(result)
          return true;
        }
      }
      return false;
    },
    saveFormData(dataToSave) {
      console.log("Saving form data in PackageOrderGeneratorAssistant")
      console.log(dataToSave)
      this.orderData = dataToSave;
      this.isOrderToDivide = dataToSave.toDivide
    },
    cancelOrder(){
      Swal.fire({
        title: "Anulowanie zamówienia",
        text: "Czy na pewno chcesz anulować tworzenie zamówienia?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Tak, anuluj",
        cancelButtonText: "Nie, kontynuuj"
      }).then((result) => {
        if (result.isConfirmed) {
          this.$emit('onCancelOrder', null);
        }
      });

    },

    saveData() {
      const orderDataValid = this.applyOrderDataForm();
      if (!orderDataValid || this.orderDrugstoresCurrent.length === 0) {
        if(this.orderDrugstoresCurrent.length === 0) {
          this.drugstoresNamesInputClass = "form-control is-invalid";
        }else {
          this.drugstoresNamesInputClass = "form-control";
        }


        Swal.fire({
          title: "Dane niepoprawne!",
          text: "Uzupełnij wymagane dane zamówienia, aby dodać zamówienie",
          icon: "error",
          customClass: {
            container: "swal-highest"
          },

        })
        return;
      }


      var savePayload = {
        orderName: this.orderData.orderName,
        orderCreationDate: this.orderData.orderCreationDate,
        isDivided: this.orderData.toDivide,
        supplierGuid: this.orderData.centralSupplierGuid,
        wholesalerGuid: this.orderData.wholesalerGuid,
        notifications:this.orderData.notifications,
        drugstoreClientsIds: this.orderDrugstoresCurrent.map(drugstore => drugstore.drugstoreClientId),
        dividerMainDrugstoreClientId: this.orderData.dividerMainDrugstoreClientId,
        creator: user.displayName,
        doCreateProspect: this.orderData.doCreateProspect,
        prospectExpiryDate: this.orderData.prospectExpiryDate,
        prospectCloseDate: this.orderData.prospectCloseDate,
        prospectAllowModifyAmount: this.orderData.prospectAllowModifyAmount,
        prospectAllowAddProducts: this.orderData.prospectAllowAddProducts,
        prospectAllowPurchasePrice: this.orderData.prospectAllowPurchasePrice

      };
      console.log("Saving order data from assistant:")
      console.log(savePayload)

      this.lazyloaderModule.setProgressBarMessage("Generowanie nowego zamówienia.");
      this.lazyloaderModule.setDisplayLazyLoader(true);
      this.packagesModule.httpCreateNewGroupOrder(savePayload)
          .then((response) => {
            this.$emit('onCreateSuccess', response.data.payload);
            this.lazyloaderModule.setDisplayLazyLoader(false);
          })
    }
  },
  created() {
  }
})
</script>


<style scoped>
.action-buttons{
  margin-bottom:8px;
  padding-bottom:8px;
  text-align: right;
}
</style>
